import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../../../api/queryKeys';
import {
  getAnprLog,
  getWbCameraConfig,
  updateWbCameraConfig,
  type WbCameraConfigUpdate,
} from '../../../api/wbCameraConfig';

export function useWbCameraConfig(weighbridgeEncId: string) {
  return useQuery({
    queryKey: queryKeys.wb.cameraConfig(weighbridgeEncId),
    queryFn: () => getWbCameraConfig(weighbridgeEncId),
    enabled: !!weighbridgeEncId,
  });
}

export function useUpdateWbCameraConfig(weighbridgeEncId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: WbCameraConfigUpdate) =>
      updateWbCameraConfig(weighbridgeEncId, data),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: queryKeys.wb.cameraConfig(weighbridgeEncId),
      });
    },
  });
}

export function useAnprLog(weighbridgeEncId: string) {
  return useQuery({
    queryKey: queryKeys.wb.anprLog(weighbridgeEncId),
    queryFn: () => getAnprLog(weighbridgeEncId),
    enabled: !!weighbridgeEncId,
    refetchInterval: 30_000,
  });
}
